





































































































































































import { Vue, Component } from "nuxt-property-decorator";
import GrCheckListItem from "~/components/GrCheckListItem.vue";
import LandingSiteCompanies from "~/components/LandingSiteCompanies.vue";
import GrPublicFooter from "~/components/startPageNew/GrPublicFooter.vue";
import CommonHelpers from "~/helpers/CommonHelpers";

@Component({
  components: { GrPublicFooter, GrCheckListItem, LandingSiteCompanies },
  nuxtI18n: false,
})
export default class ItJobsPage extends Vue {
  tab = 0;

  get rootUrl(): string {
    return CommonHelpers.getBaseUrl();
  }

  get description(): string {
    return "Jobbar du i techbranschen? Matchas mot attraktiva IT-jobb i Malmö på Gritify – det enkla sättet att ro drömjobbet iland på dina egna villkor.";
  }

  get title(): string {
    return "Upptäck lediga ingenjörsjobb i Malmö – Gritify";
  }

  head() {
    return {
      title: this.title,
      titleTemplate: "%s",
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          property: "og:title",
          content: this.title,
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:url",
          content: `${this.rootUrl}${this.$route.path}`,
        },
        {
          property: "og:description",
          content: this.description,
        },
        {
          name: "twitter:title",
          content: this.title,
        },
        {
          name: "twitter:description",
          content: this.description,
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
    };
  }

  get titleFontSize(): string {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
      case "sm":
        return "30px";
      case "md":
        return "40px";
      case "lg":
      case "xl":
        return "60px";
    }
  }

  get getStartedLink(): string {
    return this.localePath({
      name: "talentStart-createProfileStart",
    });
  }
}
